import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import Watermark from "../components/Watermark";

export default function NotFound() {
  return (
    <section
      className="page-first-section relative flex items-center justify-center overflow-hidden"
      style={{ minHeight: "calc(80vh - var(--nav-h))", paddingBottom: "clamp(2.5rem,6vw,6rem)" }}
      data-testid="notfound-section"
    >
      <Watermark word="404" />
      <div className="mt-container relative z-10 text-center">
        <p className="font-mono text-[0.7rem] tracking-mt uppercase mb-5" style={{ color: "var(--mt-text-muted)" }}>
          Error · 404
        </p>
        <h1 className="font-display font-extralight text-[clamp(2.5rem,7vw,6rem)]" style={{ lineHeight: 1.1, paddingBottom: "0.06em" }}>
          This thread <span className="italic mt-chrome-text mt-keep-anim" style={{ fontWeight: 600 }}>doesn't exist.</span>
        </h1>
        <p className="mt-italic-silver text-base sm:text-lg mt-6 max-w-md mx-auto">
          The page you're looking for was never woven, or has since unraveled. Let's get you back.
        </p>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link to="/" className="mt-btn mt-rainbow-edge" data-testid="notfound-home">
            <Home size={14} /> Back Home
          </Link>
          <Link to="/shop" className="mt-btn" data-testid="notfound-shop">
            Browse the Drop <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
